module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_45_UP_RIGHT.d3237c57.png";